
import { useContext, useEffect, useState } from 'react';
import { ClientContext } from '../../context/clientContext/ClientContext';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import TableComponent from '../../components/tableComponent/TableComponent';
import './client.css';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import { useParams, useNavigate } from 'react-router-dom';
import PaginationComponent from '../../components/paginationComponent/PaginationComponent';
import PageSizeComponent from '../../components/pageSizeComponent/PageSizeComponent';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import { wilayas, communes, typeClients, validStates } from '../../data.js';
import FilterInput from '../../components/filterInput/FilterInput.jsx';
import ModalComponent from '../../components/modalComponent/ModalComponent.jsx';
import FormInput from '../../components/formInput/FormInput.jsx';
import SubLoadingComponent from '../../components/subLoadingComponent/SubLoadingComponent.jsx';
import { addClient, getClients, ToggleActiveClient, updateClient } from '../../context/clientContext/apiCalls.js';
import { EntrepriseContext } from '../../context/entrepriseContext/EntrepriseContext.js';
import { getEntreprisesMini } from '../../context/entrepriseContext/apiCalls.js';
import ImageLoader from '../../components/imageLoader/ImageLoader.jsx';
import { getAgencesByWilaya } from '../../context/agenceContext/apiCalls.js';
import { AgenceContext } from '../../context/agenceContext/AgenceContext.js';
import { AuthContext } from '../../context/authContext/AuthContext.js';

function Client() {
    const { clients, dispatch, isFetching, error, client, isFetchingAdd, errorAdd, isFetchingUpdate, errorUpdate, isFetchingActivate, errorActivate, count: pages } = useContext(ClientContext);
    const { dispatch: dispatchEntreprise, entreprisesMini } = useContext(EntrepriseContext);
    const { dispatch: dispatchAgence, agencesByWilaya } = useContext(AgenceContext);
    const { user } = useContext(AuthContext)

    const [type, setType] = useState(typeClients[0]);
    const [username, setUsername] = useState("");
    const [wilaya, setWilaya] = useState(wilayas[0]);
    const [commune, setCommune] = useState(communes[0][0]);
    const [nom, setNom] = useState("");
    const [prenom, setPrenom] = useState("");
    const [email, setEmail] = useState("");
    const [entreprise, setEntreprise] = useState({ nom: "Choisir Entreprise", id: 0, });

    const { page = 1 } = useParams();
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(10);
    const listItems = [5, 10, 20, 30, 40, 50, 100];

    useEffect(() => {
        getClients(dispatch, pageSize, page, type.id, username, wilaya.id, commune.id, nom, prenom, email, entreprise.id);
    }, [dispatch, page, pageSize, type, username, wilaya, commune, nom, prenom, email, entreprise])

    useEffect(() => {
        setCommune(communes[wilaya.id][0]);
    }, [wilaya])

    useEffect(() => {
        navigate(`/clients/1`);
    }, [type, username, wilaya, commune, nom, prenom, email, entreprise.id])

    useEffect(() => {
        getEntreprisesMini(dispatchEntreprise);
        getAgencesByWilaya(dispatchAgence);
    }, [])


    /**************  Ajouter Modal  **************/
    const [modalAddActive, setModalAddActive] = useState(false);
    const [addType, setAddType] = useState(typeClients[0]);
    const [addUsername, setAddUsername] = useState("");
    const [addPassword, setAddPassword] = useState("");
    const [addErrorBox, setAddErrorBox] = useState("");
    const [addWilaya, setAddWilaya] = useState(wilayas[0]);
    const [addCommune, setAddCommune] = useState(communes[0][0]);
    const [addNom, setAddNom] = useState("");
    const [addPrenom, setAddPrenom] = useState("");
    const [addEmail, setAddEmail] = useState("");
    const [addTel1, setAddTel1] = useState("");
    const [addTel2, setAddTel2] = useState("");
    const [addEntreprise, setAddEntreprise] = useState({ nom: "Choisir Entreprise", id: 0, });
    const [addCarteNumero, setAddCarteNumero] = useState("");

    useEffect(() => {
        setAddCommune(communes[addWilaya.id][0]);
    }, [addWilaya])

    useEffect(() => {
        if (addType.id == 5 || addType.id == 6) {
            getEntreprisesMini(dispatchEntreprise);
        }
    }, [addType])
    useEffect(() => {
        if (Object.keys(client).length !== 0) {
            getClients(dispatch, pageSize, page, type.id, username, wilaya.id, commune.id, nom, prenom, email, entreprise.id);
            setAddType(typeClients[0]);
            setAddUsername('');
            setAddPassword('');
            setAddWilaya(wilayas[0]);
            setAddCommune(communes[0][0]);
            setAddNom('');
            setAddPrenom('');
            setAddEmail('');
            setAddTel1('');
            setAddTel2('');
            setAddCarteNumero('');
            setModalAddActive(false);
            setAddErrorBox("");
            setAddEntreprise({ nom: "Choisir Entreprise", id: 0, });
        }
    }, [client])

    useEffect(() => {
        if (errorAdd != false) {
            setAddErrorBox(errorAdd);
            setModalAddActive(true);
        }
    }, [errorAdd])

    const handleAddClient = () => {
        if (addType.id === 0) {
            setAddErrorBox('Vous devez définir le Type');
            return;
        }
        if ((addType.id == 5 || addType.id == 6) && (addEntreprise.id == 0)) {
            setAddErrorBox("Vous devez compléter l'entreprise");
            return;
        }
        if (addUsername.trim() == "") {
            setAddErrorBox('Vous devez compléter le Username');
            return;
        }
        if (addPassword.trim() == "") {
            setAddErrorBox('Vous devez compléter le Passsword');
            return;
        }
        if (addWilaya.id === 0) {
            setAddErrorBox('Vous devez compléter la Wilaya');
            return;
        }
        if (addCommune.id === 0) {
            setAddErrorBox('Vous devez compléter la Commune');
            return;
        }
        if (addNom.trim() == "") {
            setAddErrorBox('Vous devez compléter le Nom');
            return;
        }
        if (addTel1.trim() == "") {
            setAddErrorBox('Vous devez compléter le Tel1');
            return;
        }
        if (addCarteNumero.length !== 0 && addCarteNumero.length !== 18) {
            setAddErrorBox('Numero de carte non valide');
            return;
        }
        addClient(dispatch, addType.id, addEntreprise.id, addUsername, addPassword, addWilaya.id, addCommune.id, addNom, addPrenom, addEmail, addTel1, addTel2, addCarteNumero);
    }

    /**************  End Ajouter Modal  **************/

    /**************  Update Modal  **************/
    const [modalUpdateActive, setModalUpdateActive] = useState(false);
    const [updateId, setUpdateId] = useState("");
    const [updateType, setUpdateType] = useState(typeClients[0]);
    const [updateUsername, setUpdateUsername] = useState("");
    const [updatePassword, setUpdatePassword] = useState("");
    const [updateErrorBox, setUpdateErrorBox] = useState("");
    const [updateWilaya, setUpdateWilaya] = useState(wilayas[0]);
    const [updateCommune, setUpdateCommune] = useState(communes[0][0]);
    const [updateNom, setUpdateNom] = useState("");
    const [updatePrenom, setUpdatePrenom] = useState("");
    const [updateEmail, setUpdateEmail] = useState("");
    const [updateTel1, setUpdateTel1] = useState("");
    const [updateTel2, setUpdateTel2] = useState("");
    const [updateEntreprise, setUpdateEntreprise] = useState({ nom: "Choisir Entreprise", id: 0, });

    const [updateCarteNumero, setUpdateCarteNumero] = useState("");
    const [updateCarteFileImg, setUpdateCarteFileImg] = useState(null);

    const updateModalUpdateActive = (id, type, entrepriseId, username, wilayaa, communee, nom, prenom, email, tel1, tel2, carteNumero, carteFileImg) => {
        setModalUpdateActive(true);
        setUpdateId(id);
        setUpdateType(typeClients.filter(item => item.id == type)[0]);
        setUpdateEntreprise(entreprisesMini.filter(item => item.id == entrepriseId)[0])
        setUpdateUsername(username);
        setUpdateWilaya(wilayas.filter(item => item.id == wilayaa)[0]);
        setUpdateCommune(communes[wilayaa].filter(item => item.id == communee)[0]);
        setUpdateNom(nom);
        setUpdatePrenom(prenom);
        setUpdateEmail(email);
        setUpdateTel1(tel1);
        setUpdateTel2(tel2);
        setUpdateCarteNumero(carteNumero);
        setUpdateCarteFileImg(carteFileImg);
    }
    useEffect(() => {
        getEntreprisesMini(dispatchEntreprise);
    }, [updateType])

    useEffect(() => {
        if (Object.keys(client).length !== 0) {
            getClients(dispatch, pageSize, page, type.id, username, wilaya.id, commune.id, nom, prenom, email, entreprise.id);
            setUpdateType(typeClients[0]);
            setUpdateUsername('');
            setUpdatePassword('');
            setUpdateWilaya(wilayas[0]);
            setUpdateCommune(communes[0][0]);
            setUpdateNom('');
            setUpdatePrenom('');
            setUpdateEmail('');
            setUpdateTel1('');
            setUpdateTel2('');
            setModalUpdateActive(false);
            setUpdateErrorBox("");
            setUpdateEntreprise({ nom: "Choisir Entreprise", id: 0, });
            setUpdateCarteNumero('');
            setUpdateCarteFileImg(null);
        }
    }, [client])

    useEffect(() => {
        if (errorUpdate != false) {
            setUpdateErrorBox(errorUpdate);
            setModalUpdateActive(true);
        }
    }, [errorUpdate])

    const handleUpdateAgence = () => {
        if (updateType.id === 0) {
            setUpdateErrorBox('Vous devez définir le Type');
            return;
        }
        if ((updateType.id == 5 || updateType.id == 6) && (updateEntreprise.id == 0)) {
            setUpdateErrorBox("Vous devez compléter l'entreprise");
            return;
        }
        if (updateUsername.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Username');
            return;
        }
        if (updateWilaya.id === 0) {
            setUpdateErrorBox('Vous devez compléter la Wilaya');
            return;
        }
        if (updateCommune.id === 0) {
            setUpdateErrorBox('Vous devez compléter la Commune');
            return;
        }
        if (updateNom.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Nom');
            return;
        }
        if (updateTel1.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Tel1');
            return;
        }
        if (updateCarteNumero.length !== 0 && updateCarteNumero.length !== 18) {
            setUpdateErrorBox('Numero de carte non valide');
            return;
        }

        if (updateType.id == 5 || updateType.id == 6) {
            updateClient(dispatch, updateId, updateType.id, updateEntreprise.id, updateUsername, updatePassword, updateWilaya.id, updateCommune.id, updateNom, updatePrenom, updateEmail, updateTel1, updateTel2, updateCarteNumero);
        } else {
            updateClient(dispatch, updateId, updateType.id, null, updateUsername, updatePassword, updateWilaya.id, updateCommune.id, updateNom, updatePrenom, updateEmail, updateTel1, updateTel2, updateCarteNumero);
        }
    }

    /**************  End Update Modal  **************/

    const toggleActive = (clientId) => {
        ToggleActiveClient(dispatch, clientId);
    }


    return (
        <div className='container-global'>
            <AdminSideBar activeTab="client" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Clients et Clients Business</span>
                </div>

                {
                    error ? <ErrorComponent error={error} /> : (
                        <>
                            <div className="filter">
                                <span className="adv-research">Recherche Avancée</span>
                                <div className="filter-content">
                                    <DropDownComponent data={typeClients} itemChoisir={type} setItemChoisir={setType} filter />
                                    <DropDownComponent data={[{ nom: "Choisir Entreprise", id: 0, }, ...entreprisesMini]} itemChoisir={entreprise} setItemChoisir={setEntreprise} filter />
                                    <FilterInput placeholder={"Username"} setItem={setUsername} />
                                    {
                                        user.role && (
                                            (user.role === 1 || user.role === 2) && (
                                                <>
                                                    <DropDownComponent data={wilayas} itemChoisir={wilaya} setItemChoisir={setWilaya} filter />
                                                    <DropDownComponent data={communes[wilaya.id]} itemChoisir={commune} setItemChoisir={setCommune} filter />
                                                </>
                                            )
                                        )
                                    }
                                    <FilterInput placeholder={"Nom"} setItem={setNom} />
                                </div>
                            </div>

                            {
                                (user.role === 1 || user.role === 2 || user.role === 3) && (
                                    <div className="add-item">
                                        <span className='color-1' onClick={() => setModalAddActive(true)}>Ajouter</span>
                                    </div>
                                )
                            }

                            {
                                isFetching ? <LoadingComponent /> : (
                                    clients.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span>
                                        : (
                                            <>
                                                <PageSizeComponent listItems={listItems} pageSize={pageSize} setPageSize={setPageSize} itemLocation='clients' />
                                                <div className="content">
                                                    {
                                                        <>
                                                            <TableComponent headers={user.role && (user.role === 1 || user.role === 2 || user.role === 3)
                                                                ? ['', 'Id', 'Type', 'Entreprise', 'Username', 'Wilaya', 'Commune', 'Nom', 'Date', 'Action']
                                                                : ['', 'Id', 'Type', 'Entreprise', 'Username', 'Wilaya', 'Commune', 'Nom', 'Date']
                                                            }>
                                                                {
                                                                    clients.map((client, index) => (
                                                                        // <tr key={index} style={client.active == 0 ? {background: 'rgba(248, 103, 0, 0.2)'} : {}}>
                                                                        <tr key={index}>
                                                                            <td>
                                                                                {
                                                                                    (client.valid === 1) && (
                                                                                        <span className="tooltip">
                                                                                            <span className="material-symbols-rounded" style={{ color: "#00c02c", fontSize: "26px", fontWeight: "600" }}>star</span>
                                                                                            <span className="tooltip-text on">Cet client est valider</span>
                                                                                        </span>
                                                                                    )
                                                                                }
                                                                            </td>
                                                                            <td>{client.id}</td>
                                                                            <td>{client.RoleId === 5 ? "CB" : (client.RoleId === 6 ? "CBA" : "Client")}</td>
                                                                            <td>{(client.RoleId === 5 || client.RoleId === 6) ? client.Entreprise.nom : (<span className="material-symbols-rounded">align_vertical_center</span>)}</td>
                                                                            <td>{client.username}</td>
                                                                            <td>{wilayas.filter(item => item.id == client.Userinfo.wilaya)[0]['nom']}</td>
                                                                            <td>{communes[client.Userinfo.wilaya].filter(item => item.id == client.Userinfo.commune)[0] ? communes[client.Userinfo.wilaya].filter(item => item.id == client.Userinfo.commune)[0]['nom'] : ""}</td>
                                                                            <td>{client.Userinfo.nom}</td>
                                                                            <td>{client.createdAt.slice(0, 10)}</td>
                                                                            {
                                                                                user.role && (user.role === 1 || user.role === 2 || user.role === 3) && (
                                                                                    <td>
                                                                                        <span className='update' onClick={() => updateModalUpdateActive(client.id, client.RoleId, (client.RoleId === 5 || client.RoleId === 6) ? client.Entreprise.id : 1, client.username, client.Userinfo.wilaya, client.Userinfo.commune, client.Userinfo.nom, client.Userinfo.prenom, client.Userinfo.email, client.Userinfo.tel1, client.Userinfo.tel2 || "", client.Userinfo.numero_carte || "", client.Userinfo.image_carte)}>Modifier</span>
                                                                                        <span className='detail' onClick={() => toggleActive(client.id)} style={isFetchingActivate ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                                                                            {
                                                                                                isFetchingActivate ? (
                                                                                                    client.active == 0 ? "Activer..." : "Disactiver..."
                                                                                                ) : (
                                                                                                    client.active == 0 ? "Activer" : "Disactiver"
                                                                                                )
                                                                                            }
                                                                                        </span>
                                                                                    </td>
                                                                                )
                                                                            }
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </TableComponent>
                                                            {
                                                                (pages > 1) && (<PaginationComponent page={page} pages={pages} item='clients' />)
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </>
                                        )
                                )
                            }
                        </>
                    )
                }

            </div>


            {/*  Modal Components */}
            {
                <>
                    <ModalComponent modalActive={modalAddActive} setModalActive={setModalAddActive} setErrorBox={setAddErrorBox} title="Ajouter Client">
                        {
                            isFetchingAdd ? <SubLoadingComponent /> : (
                                <form>
                                    {addErrorBox !== "" && (<div className='box-error'>{addErrorBox}</div>)}
                                    <div className='side-to-side'>
                                        <DropDownComponent data={typeClients} itemChoisir={addType} setItemChoisir={setAddType} />
                                        {
                                            (addType.id == 5 || addType.id == 6) && (
                                                <DropDownComponent data={entreprisesMini} itemChoisir={addEntreprise} setItemChoisir={setAddEntreprise} />
                                            )
                                        }
                                    </div>
                                    <div className='side-to-side'>
                                        <FormInput label='Username *' itemInput={addUsername} setItemInput={setAddUsername} auth />
                                        <FormInput label='Password *' itemInput={addPassword} setItemInput={setAddPassword} auth />
                                        <FormInput label='Nom *' itemInput={addNom} setItemInput={setAddNom} auth />
                                    </div>
                                    <div className='side-to-side'>
                                        <FormInput label='Tel1 *' itemInput={addTel1} setItemInput={setAddTel1} istype='number' auth />
                                        <FormInput label='Tel2' itemInput={addTel2} setItemInput={setAddTel2} istype='number' auth />
                                        <FormInput label='Email' itemInput={addEmail} setItemInput={setAddEmail} auth />
                                    </div>
                                    <div className='side-to-side'>
                                        <DropDownComponent data={wilayas} itemChoisir={addWilaya} setItemChoisir={setAddWilaya} />
                                        <DropDownComponent data={communes[addWilaya.id]} itemChoisir={addCommune} setItemChoisir={setAddCommune} />
                                    </div>
                                    <FormInput label="Numero du Carte" itemInput={addCarteNumero} setItemInput={setAddCarteNumero} auth istype='number' />
                                    <div className='button' onClick={handleAddClient}>
                                        <span>Valider</span>
                                    </div>
                                </form>
                            )
                        }
                    </ModalComponent>

                    <ModalComponent modalActive={modalUpdateActive} setModalActive={setModalUpdateActive} setErrorBox={setUpdateErrorBox} title="Modifier Client">
                        {
                            isFetchingUpdate ? <SubLoadingComponent /> : (
                                <form>
                                    {updateErrorBox !== "" && (<div className='box-error'>{updateErrorBox}</div>)}
                                    <div className='side-to-side'>
                                        <DropDownComponent data={typeClients} itemChoisir={updateType} setItemChoisir={setUpdateType} />
                                        {
                                            (updateType.id == 5 || updateType.id == 6) && (
                                                <DropDownComponent data={entreprisesMini} itemChoisir={updateEntreprise} setItemChoisir={setUpdateEntreprise} />
                                            )
                                        }
                                    </div>
                                    <div className='side-to-side'>
                                        <FormInput label='Username *' itemInput={updateUsername} setItemInput={setUpdateUsername} auth />
                                        <FormInput label='Password *' itemInput={updatePassword} setItemInput={setUpdatePassword} auth />
                                        <FormInput label='Nom *' itemInput={updateNom} setItemInput={setUpdateNom} auth />
                                    </div>
                                    <div className='side-to-side'>
                                        <FormInput label='Tel1 *' itemInput={updateTel1} setItemInput={setUpdateTel1} auth />
                                        <FormInput label='Tel2' itemInput={updateTel2} setItemInput={setUpdateTel2} auth />
                                        <FormInput label='Email' itemInput={updateEmail} setItemInput={setUpdateEmail} auth />
                                    </div>
                                    <div className='side-to-side'>
                                        <DropDownComponent data={wilayas} itemChoisir={updateWilaya} setItemChoisir={setUpdateWilaya} />
                                        <DropDownComponent data={communes[updateWilaya.id]} itemChoisir={updateCommune} setItemChoisir={setUpdateCommune} />
                                    </div>
                                    <FormInput label="Numero du Carte" itemInput={updateCarteNumero} setItemInput={setUpdateCarteNumero} auth istype='number' />
                                    {/* {
                                        updateCarteFileImg && (
                                            <ImageLoader imageLabel={"Attacher Image"} imgUrl={updateCarteFileImg} subPath='uploadCarte' imgWidth={"300px"} imgHeight={"200px"} downloadIcon={true} />
                                        )
                                    } */}

                                    <div className='button' onClick={handleUpdateAgence}>
                                        <span>Terminer</span>
                                    </div>
                                </form>
                            )
                        }
                    </ModalComponent>
                </>
            }
            {/*  End Modal Components */}


        </div>
    )
}
export default Client